/** Escapes a value for use inside an OData string literal (single quotes doubled). */
export function escapeODataValue(value: string | undefined): string | undefined {
    return value ? value.replace(/'/g, "''") : undefined;
}
